module.exports = __webpack_public_path__ + "static/media/background-letters.53696249.png";